import {OperatingAreaEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {OperatingAreaAction} from "./OperatingAreaActionMenu";
import {useOperatingAreaMutation} from "../../../hooks/useOperatingAreaMutation";

export type UseOperatingAreaActionProps = {}

export type UseOperatingAreaActionResult = {
  onOperatingAreaActionClick: (operatingArea: OperatingAreaEntity, action: OperatingAreaAction) => void;
}

export const useOperatingAreaAction = (props: UseOperatingAreaActionProps = {}): UseOperatingAreaActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteOperatingArea,
  } = useOperatingAreaMutation()

  const _onOperatingAreaActionClick = useCallback((operatingArea: OperatingAreaEntity, action: OperatingAreaAction) => {
    if (action === "EDIT") {
      navigate(`/operating-areas/form`, {state: {id: operatingArea.id}})
    } else if (action === "DELETE") {
      deleteOperatingArea(operatingArea.id, {onSuccess: () => navigate(-1)})
    }
  }, [navigate, deleteOperatingArea])

  return {
    onOperatingAreaActionClick: _onOperatingAreaActionClick
  }
}
